// 用户信息接口
import http from "@/promise/http"
const CONTROLLER_NAME = "/user/";

// 用户信息
export const getDetail = () => {
    return http.get(CONTROLLER_NAME.concat("info"));
};

// 更新用户信息
export const postUpdateInfo = form => {
    return http.post(CONTROLLER_NAME.concat("update-info"), form);
  };